// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';

type IssueKey = string;

const CLOSED = 'CLOSED' as const;
const SHOWING_ISSUE = 'SHOWING_ISSUE' as const;

export const SidebarStatuses = {
	CLOSED,
	SHOWING_ISSUE,
} as const;

type Closed = {
	status: typeof CLOSED;
};

type ShowingIssue = {
	status: typeof SHOWING_ISSUE;
	issueKey: IssueKey;
};

type SidebarState = Closed | ShowingIssue;
type State = {
	state: SidebarState;
};

const initialState: State = {
	state: {
		status: CLOSED,
	},
};

export const actions = {
	close:
		(): Action<State> =>
		({ setState }) =>
			setState({ state: { status: CLOSED } }),
	showIssue:
		(issueKey: IssueKey): Action<State> =>
		({ setState }) =>
			setState({ state: { status: SHOWING_ISSUE, issueKey } }),
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'versionDetailsSidebarStore',
	initialState,
	actions,
});

const useStore = createHook(Store);

export const useSidebarStore = () => {
	const [{ state }, sidebarActions] = useStore();
	return [state, sidebarActions] as const;
};

const useSidebarWithoutState = createHook(Store, {
	selector: null,
});

export const useSidebarActions = () => {
	const [, sidebarActions] = useSidebarWithoutState();
	return sidebarActions;
};
